<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Create New Public Space
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false; selected.category = 0;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="pt-4 pb-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Space Name" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Space Name
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Ex : Ruang Meeting"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      v-model="form.name"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Type" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Type
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      
                      :color="set_color"
                      placeholder="Ex : Image Slider"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      
                      :items="type"
                      item-text="text"
                      item-value="value"
                      :item-color="set_color"
                      
                      clearable
                      @click:clear="form.type = ''"
                      
                      v-model="form.type"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider v-if="form.type !== 'video' && form.type !== 'web_view'"
                    name="Duration(s)" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Duration (seconds)
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense

                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      type="number"
                      min="0"

                      @focus="$event.target.select()"
                      @keyup="form.duration_minutes = form.duration_minutes === '' || parseInt(form.duration_minutes) < 1 ? 1 : form.duration_minutes;"
                      @blur="form.duration_minutes = form.duration_minutes === '' || parseInt(form.duration_minutes) < 1 ? 1 : form.duration_minutes;"

                      :color="set_color"
                      placeholder="Ex : 15"
                      :append-icon="valid && form.duration_minutes !== '' ? 'mdi-check-circle-outline' : ''"

                      suffix="Seconds"

                      v-model="form.duration_minutes"
                      :success="valid && form.duration_minutes !== ''"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Information" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div 
                      class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Information
                    </div>

                    <v-textarea
                      filled
                      rounded
                      dense
                      rows="4"

                      :color="set_color"
                      placeholder="Ex : Banner slider full screen untuk ruang meeting"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      v-model="form.desc"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-textarea>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save('dialog')"
                :loading="process.form"
                :disabled="process.form"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text"
                style="border-radius: 10px;">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Save
              </v-btn>

              <v-btn
                @click="dialog.form = false; selected.category = 0;"
                :disabled="process.form"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text"
                style="border-radius: 10px;">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
            class="pa-2">
            <v-card-title 
              class="d-flex align-center py-0 px-3 text-right popup-header">
              Delete

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = 0;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mx-4 mt-3 mb-2"/>

            <v-card-text 
              class="body-1 font-weight-light text-first mt-3">
              Are you sure to delete <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> ?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text"
                style="border-radius: 10px;">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Yes
              </v-btn>

              <v-btn
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = 0;"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text"
                style="border-radius: 10px;">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.schedule"
          @keydown.esc="dialog.schedule = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Edit
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.schedule = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="pt-4 pb-0">
              <div
                class="mb-6">
                <div v-if="form_schedule.url !== ''">
                  <v-card v-if="!form_schedule.play"
                    @click="form_schedule.play = !form_schedule.play"

                    flat
                    color="#f5f5f5"
                    width="100%"
                    height="200"
                    class="d-flex align-center justify-center"
                    style="border-radius: 10px;">
                    <v-icon
                      size="60"
                      :color="set_color"
                      class="cursor-pointer">
                      mdi-play-circle
                    </v-icon>

                    <v-icon 
                      @click="form_schedule.url = ''"
                      color="red"
                      class="cursor-pointer"
                      style="position: absolute; top: -8px; right: -8px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card>
                  
                  <v-card v-else
                    flat
                    color="#f5f5f5"
                    width="100%"
                    height="200"
                    class="d-flex align-center justify-center"
                    style="border-radius: 10px;">
                    <video 
                      width="100%"
                      height="200"
                      autoplay
                      controls
                      style="border-radius: 10px;">
                      <source 
                        :src="form_schedule.url"
                        :type="`video/${form_schedule.url.split('.').pop()}`">
                    </video>

                    <v-icon 
                      @click="form_schedule.url = ''"
                      color="red"
                      class="cursor-pointer"
                      style="position: absolute; top: -8px; right: -8px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card>
                </div>

                <div v-else>
                  <videoupload 
                    v-model="upload.schedule">
                    <div 
                      slot="activator">
                      <v-card
                        flat
                        color="#f5f5f5"
                        class="cursor-pointer"
                        style="border-radius: 10px;">
                        <v-card-text
                          class="d-flex align-center justify-center"
                          style="height: 200px;">
                          <v-avatar v-if="!process.file"
                            tile
                            size="50">
                            <v-icon
                              size="50"
                              color="#B9B9B9">
                              mdi-plus-circle-outline
                            </v-icon>
                          </v-avatar>
    
                          <v-progress-circular v-else
                            :rotate="-90"
                            :size="50"
                            :width="5"
                            :value="onProgress"
                            :color="set_color">
                            {{ onProgress }}
                          </v-progress-circular>
                        </v-card-text>
                      </v-card>
                    </div>
                  </videoupload>
                </div>
              </div>
              
              <div>
                <div class="body-2 mb-2">
                  Days
                </div>

                <v-select
                  filled
                  rounded
                  dense
                  
                  :color="set_color"
                  placeholder="Ex : Monday"
                  :append-icon="form_schedule.day.length > 0 ? 'mdi-check-circle-outline' : ''"
                  
                  :items="days"
                  :item-color="set_color"

                  multiple
                  
                  clearable
                  @click:clear="form_schedule.day = []"
                  
                  v-model="form_schedule.day"
                  :success="form_schedule.day.length > 0"
                  style="border-radius: 10px;">
                </v-select>
              </div>

              <div>
                <div class="body-2 mb-2">
                  Start Hour
                </div>

                <v-menu
                  ref="time"
                  v-model="time"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form_schedule.start"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Ex : 12:00:00"
                      :append-icon="form_schedule.start !== '' ? 'mdi-check-circle-outline' : ''"

                      clearable
                      @click:clear="form_schedule.start = ''"
                      v-on="on"
                      v-bind="attrs"
                      
                      v-model="form_schedule.start"
                      :success="form_schedule.start !== ''"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </template>

                  <v-time-picker
                    v-if="time"
                    v-model="form_schedule.start"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.time.save(`${form_schedule.start}:00`)">
                  </v-time-picker>
                </v-menu>
              </div>

              <div>
                <div class="body-2 mb-2">
                  Duration (seconds)
                </div>

                <v-text-field
                  filled
                  rounded
                  dense

                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  type="number"
                  min="0"

                  @focus="$event.target.select()"
                  @keyup="form_schedule.duration = form_schedule.duration === '' || parseInt(form_schedule.duration) < 1 ? 1 : form_schedule.duration;"
                  @blur="form_schedule.duration = form_schedule.duration === '' || parseInt(form_schedule.duration) < 1 ? 1 : form_schedule.duration;"

                  :color="set_color"
                  placeholder="Ex : 15"
                  :append-icon="form_schedule.duration !== '' ? 'mdi-check-circle-outline' : ''"

                  suffix="Seconds"

                  v-model="form_schedule.duration"
                  :success="form_schedule.duration !== ''"
                  style="border-radius: 10px;">
                </v-text-field>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save('dialog')"
                :loading="process.form"
                :disabled="process.form"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text"
                style="border-radius: 10px;">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Save
              </v-btn>

              <v-btn
                @click="dialog.schedule = false"
                :disabled="process.form"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text"
                style="border-radius: 10px;">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Public Space
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pb-0 pr-1">
            <v-col 
              cols="12"
              md="3">
              <v-card 
                flat
                min-height="calc(100vh - 190px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-list
                    v-for="(item, index) in list"
                    :key="index"
                    dense
                    class="cursor-pointer py-0 mb-4"
                    style="border-radius: 10px;"
                    :style="selected.category === index ? `background: ${set_color};` : 'background: #f5f5f5;'">
                    <v-list-item
                      @click="selected.category = index"
                      style="border-radius: 10px;">
                      <v-list-item-content>
                        <v-list-item-title
                          class="body-2 text-capitalize"
                          :class="selected.category === index ? `white--text` : 'black--text'"
                          :style="selected.category === index ? '' : 'opacity: 60%;'"
                          style="margin-bottom: 4px; min-height: 18px;">
                          {{ item.name }}
                        </v-list-item-title>

                        <v-list-item-subtitle
                          class="caption text-capitalize"
                          :class="selected.category === index ? `white--text` : 'black--text'"
                          :style="selected.category === index ? '' : 'opacity: 60%;'">
                          {{ item.type === 'slider' ? 'Image Slider' : item.type === 'tv_ads' ? 'Tv & Ads' : item.type === 'video' ? 'Video' : 'Webview' }}
                        </v-list-item-subtitle>

                        <v-icon 
                          @click="toDelete(item.id)"
                          size="20"
                          color="red"
                          class="cursor-pointer"
                          style="position: absolute; font-size: 16px; right: -5px; top: -5px;">
                          mdi-close-circle
                        </v-icon>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-btn
                    @click="dialog.form = true; selected.category = ''; reset();"
                    block
                    x-large
                    elevation="0"
                    style="border-radius: 10px;">
                    <v-avatar
                      tile
                      size="30">
                      <v-icon
                        size="30"
                        color="#B9B9B9">
                        mdi-plus-circle-outline
                      </v-icon>
                    </v-avatar>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col 
              cols="12"
              md="9">
              <v-card 
                flat
                height="calc(100vh - 190px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text v-if="list.length > 0 && selected.category !== ''">
                  <ValidationObserver 
                    ref="form_card">
                    <v-form>
                      <v-row
                        align="center">
                        <v-col
                          cols="12"
                          md="7"
                          class="py-0">
                          <div>
                            <div
                              class="title font-weight-bold black--text"
                              style="margin-bottom: 2px;">
                              {{ list[selected.category].name }}

                              <v-icon 
                                @click="dialog.form = true; reset(list[selected.category]);"
                                size="20"
                                :color="set_color"
                                class="cursor-pointer">
                                mdi-square-edit-outline
                              </v-icon>
                            </div>

                            <div
                              class="text-capitalize"
                              style="margin-bottom: 2px;">
                              Tipe : {{ list[selected.category].type === 'slider' ? 'Image Slider' : list[selected.category].type === 'tv_ads' ? 'Tv & Ads' : list[selected.category].type === 'video' ? 'Video' : 'Webview' }}
                            </div>

                            <div>
                              Information : {{ list[selected.category].desc }}
                            </div>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="5"
                          class="py-0">
                          <v-row
                            justify="end">
                            <v-col v-if="list[selected.category].type !== 'video' && list[selected.category].type !== 'web_view'"
                              cols="12"
                              md="5"
                              class="py-0">
                              <div
                                class="black--text"
                                style="margin-bottom: 2px; opacity: 60%;">
                                Duration (seconds) :
                              </div>

                              <div
                                class="caption black--text"
                                style="opacity: 60%;">
                                *more than 1 image
                              </div>
                            </v-col>

                            <v-col v-if="list[selected.category].type !== 'video' && list[selected.category].type !== 'web_view'"
                              cols="12"
                              md="3"
                              class="py-0">
                              <div
                                @click="dialog.form = true; reset(list[selected.category]);"
                                class="text-center cursor-pointer"
                                style="border-radius: 8px; background: #f5f5f5; width: 75px; padding: 8px;">
                                {{ list[selected.category].duration_minutes }}
                              </div>
                            </v-col>

                            <v-col v-if="list[selected.category].type === 'video' || list[selected.category].type === 'web_view'"
                              cols="12"
                              md="3"
                              class="py-0">
                              <div
                                @click="dialog.form = true; reset(list[selected.category]);"
                                class="text-center cursor-pointer"
                                style="border-radius: 8px; font-weight: 600; background: #f5f5f5; width: 75px; padding: 8px;">
                                Edit
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                              class="py-0 pl-0">
                              <v-btn
                                @click="save('card')"
                                :loading="process.form_update"
                                :disabled="process.form_update"
                                block
                                color="#4B4B4B"
                                elevation="0"
                                class="body-2 white--text text-capitalize"
                                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                Save
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-divider 
                        class="my-5"
                        style="border-top: 2px dashed #e0e0e0;"/>

                      <v-row v-if="list.length > 0 && list[selected.category].type === 'slider'">
                        <v-col
                          v-for="(item, index) in list[selected.category].image_json_object.slider"
                          :key="index"
                          cols="12"
                          md="4">
                          <v-card 
                            flat
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 10px;">
                            <v-img 
                              width="100%"
                              height="100%"
                              alt="visuality" 
                              :src="item !== '' ? item : require('@/assets/image/image_default.png')"
                              class="ma-auto"
                              style="border-radius: 10px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <v-icon 
                              @click="list[selected.category].image_json_object.slider.splice(index, 1)"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -8px; right: -8px;">
                              mdi-close-circle
                            </v-icon>
                          </v-card>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4">
                          <folder 
                            v-model="upload.slider">
                            <div 
                              slot="activator">
                              <v-card
                                flat
                                color="#f5f5f5"
                                class="cursor-pointer"
                                style="border-radius: 10px;">
                                <v-card-text
                                  class="d-flex align-center justify-center"
                                  style="height: 200px;">
                                  <v-avatar v-if="!process.file"
                                    tile
                                    size="50">
                                    <v-icon
                                      size="50"
                                      color="#B9B9B9">
                                      mdi-plus-circle-outline
                                    </v-icon>
                                  </v-avatar>

                                  <v-progress-circular v-else
                                    :rotate="-90"
                                    :size="50"
                                    :width="5"
                                    :value="onProgress"
                                    :color="set_color">
                                    {{ onProgress }}
                                  </v-progress-circular>
                                </v-card-text>
                              </v-card>
                            </div>
                          </folder>
                        </v-col>
                      </v-row>

                      <v-row v-if="list[selected.category].type === 'tv_ads'"
                        style="height: calc(100vh - 353px);">
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0"
                          style="border-right: 1px dashed #e0e0e0;">
                          <div
                            class="d-flex align-center">
                            Slide banner

                            <span
                              class="ml-1"
                              style="opacity: 60%;">
                              840 x 2160 px
                            </span>
                          </div>

                          <v-row>
                            <v-col
                              v-for="(item, index) in list[selected.category].image_json_object.grid.col"
                              :key="index"
                              cols="12"
                              md="4">
                              <v-card 
                                flat
                                height="300"
                                class="d-flex align-center justify-center"
                                style="border-radius: 10px;">
                                <v-img 
                                  width="100%"
                                  height="100%"
                                  alt="visuality" 
                                  :src="item !== '' ? item : require('@/assets/image/image_default.png')"
                                  class="ma-auto"
                                  style="border-radius: 10px;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>

                                <v-icon 
                                  @click="list[selected.category].image_json_object.grid.col.splice(index, 1)"
                                  color="red"
                                  class="cursor-pointer"
                                  style="position: absolute; top: -8px; right: -8px;">
                                  mdi-close-circle
                                </v-icon>
                              </v-card>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4">
                              <folder 
                                v-model="upload.grid_col">
                                <div 
                                  slot="activator">
                                  <v-card
                                    flat
                                    color="#f5f5f5"
                                    class="cursor-pointer"
                                    style="border-radius: 10px;">
                                    <v-card-text
                                      class="d-flex align-center justify-center"
                                      style="height: 300px;">
                                      <v-avatar v-if="!process.file_col"
                                        tile
                                        size="50">
                                        <v-icon
                                          size="50"
                                          color="#B9B9B9">
                                          mdi-plus-circle-outline
                                        </v-icon>
                                      </v-avatar>

                                      <v-progress-circular v-else
                                        :rotate="-90"
                                        :size="50"
                                        :width="5"
                                        :value="onProgress"
                                        :color="set_color">
                                        {{ onProgress }}
                                      </v-progress-circular>
                                    </v-card-text>
                                  </v-card>
                                </div>
                              </folder>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="py-0"
                          style="border-left: 1px dashed #e0e0e0;">
                          <div
                            class="d-flex align-center">
                            Bottom banner

                            <span
                              class="ml-1"
                              style="opacity: 60%;">
                              3000 x 472 px
                            </span>
                          </div>

                          <v-row>
                            <v-col
                              v-for="(item, index) in list[selected.category].image_json_object.grid.row"
                              :key="index"
                              cols="12">
                              <v-card 
                                flat
                                height="130"
                                class="d-flex align-center justify-center"
                                style="border-radius: 10px;">
                                <v-img 
                                  width="100%"
                                  height="100%"
                                  alt="visuality" 
                                  :src="item !== '' ? item : require('@/assets/image/image_default.png')"
                                  class="ma-auto"
                                  style="border-radius: 10px;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>

                                <v-icon 
                                  @click="list[selected.category].image_json_object.grid.row.splice(index, 1)"
                                  color="red"
                                  class="cursor-pointer"
                                  style="position: absolute; top: -8px; right: -8px;">
                                  mdi-close-circle
                                </v-icon>
                              </v-card>
                            </v-col>

                            <v-col
                              cols="12">
                              <folder 
                                v-model="upload.grid_row">
                                <div 
                                  slot="activator">
                                  <v-card
                                    flat
                                    color="#f5f5f5"
                                    class="cursor-pointer"
                                    style="border-radius: 10px;">
                                    <v-card-text
                                      class="d-flex align-center justify-center"
                                      style="height: 130px;">
                                      <v-avatar v-if="!process.file_row"
                                        tile
                                        size="50">
                                        <v-icon
                                          size="50"
                                          color="#B9B9B9">
                                          mdi-plus-circle-outline
                                        </v-icon>
                                      </v-avatar>

                                      <v-progress-circular v-else
                                        :rotate="-90"
                                        :size="50"
                                        :width="5"
                                        :value="onProgress"
                                        :color="set_color">
                                        {{ onProgress }}
                                      </v-progress-circular>
                                    </v-card-text>
                                  </v-card>
                                </div>
                              </folder>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row v-if="list.length > 0 && list[selected.category].type === 'video'">
                        <v-col
                          v-for="(item, index) in list[selected.category].image_json_object.schedule"
                          :key="index"
                          cols="12"
                          md="4">
                          <div v-if="item.url !== ''">
                            <v-card v-if="!item.play"
                              @click="item.play = !item.play"
  
                              flat
                              color="#f5f5f5"
                              width="100%"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 10px;">
                              <v-icon
                                size="60"
                                :color="set_color"
                                class="cursor-pointer">
                                mdi-play-circle
                              </v-icon>
  
                              <v-icon 
                                @click="list[selected.category].image_json_object.schedule.splice(index, 1)"
                                color="red"
                                class="cursor-pointer"
                                style="position: absolute; top: -8px; right: -8px;">
                                mdi-close-circle
                              </v-icon>
                            </v-card>
                            
                            <v-card v-else
                              flat
                              color="#f5f5f5"
                              width="100%"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 10px;">
                              <video 
                                width="100%"
                                height="200"
                                autoplay
                                controls
                                style="border-radius: 10px;">
                                <source 
                                  :src="item.url"
                                  :type="`video/${item.url.split('.').pop()}`">
                              </video>
  
                              <v-icon 
                                @click="list[selected.category].image_json_object.schedule.splice(index, 1)"
                                color="red"
                                class="cursor-pointer"
                                style="position: absolute; top: -8px; right: -8px;">
                                mdi-close-circle
                              </v-icon>
                            </v-card>
                          </div>

                          <div v-else>
                            <v-card
                              flat
                              color="#f5f5f5"
                              width="100%"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 10px;">
                            </v-card>
                          </div>

                          <v-card
                            flat
                            class="mt-4"
                            style="border-radius: 10px; border: 2px dashed #e0e0e0;">
                            <v-card-text
                              class="pa-3 line-text-second">
                              <div>
                                <div
                                  class="d-flex align-start">
                                  <div>
                                    Days
                                  </div>
  
                                  <v-spacer />
  
                                  <div
                                    class="text-right one-line"
                                    style="width: 50%;">
                                    <span v-if="item.day.length > 0">
                                      {{ item.day.join(', ') }}
                                    </span>
  
                                    <span v-else>
                                      -
                                    </span>
                                  </div>
                                </div>
  
                                <div
                                  class="d-flex align-center">
                                  <div>
                                    Start Hour
                                  </div>
  
                                  <v-spacer />
  
                                  <div>
                                    {{ item.start !== '' ? item.start : '-' }}
                                  </div>
                                </div>
  
                                <div
                                  class="d-flex align-center">
                                  <div>
                                    Duration
                                  </div>
  
                                  <v-spacer />
  
                                  <div>
                                    {{ item.duration > 0 ? `${item.duration} seconds` : '-' }}
                                  </div>
                                </div>
                              </div>

                              <v-btn
                                @click="dialog.schedule = true; reset_schedule(index);"
                                block
                                color="#444444"
                                elevation="0"
                                class="body-2 text-capitalize white--text mt-2"
                                style="border-radius: 8px; font-weight: 600;">
                                Edit Item
                              </v-btn>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4">
                          <videoupload 
                            v-model="upload.schedule">
                            <div 
                              slot="activator">
                              <v-card
                                flat
                                color="#f5f5f5"
                                class="cursor-pointer"
                                style="border-radius: 10px;">
                                <v-card-text
                                  class="d-flex align-center justify-center"
                                  style="height: 200px;">
                                  <v-avatar v-if="!process.file"
                                    tile
                                    size="50">
                                    <v-icon
                                      size="50"
                                      color="#B9B9B9">
                                      mdi-plus-circle-outline
                                    </v-icon>
                                  </v-avatar>

                                  <v-progress-circular v-else
                                    :rotate="-90"
                                    :size="50"
                                    :width="5"
                                    :value="onProgress"
                                    :color="set_color">
                                    {{ onProgress }}
                                  </v-progress-circular>
                                </v-card-text>
                              </v-card>
                            </div>
                          </videoupload>
                        </v-col>
                      </v-row>

                      <v-row v-if="list.length > 0 && list[selected.category].type === 'web_view'">
                        <v-col
                          cols="12"
                          md="12">
                          <!-- <ValidationObserver 
                            ref="form">
                            <v-form> -->
                              <ValidationProvider 
                                name="Url Webview" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Url Webview
                                </div>

                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Ex : com.google.android.youtube.tv"
                                  :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                  v-model="list[selected.category].image_json_object.schedule[0].url"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-text-field>
                              </ValidationProvider>

                              <div
                                class="mb-6">
                                <div class="body-2 mb-2">
                                  Days
                                </div>

                                <div
                                  class="d-flex align-center">
                                  <div
                                    v-for="d in days"
                                    class="mr-4">
                                    <v-checkbox
                                      v-model="list[selected.category].image_json_object.schedule[0].day"
                                      label="red"
                                      :color="set_color"
                                      :value="d"
                                      class="ma-0"
                                      hide-details>
                                      <template v-slot:label>
                                        <div
                                          class="body-2 black--text"
                                          style="opacity: 60%;">
                                          {{ d }}
                                        </div>
                                      </template>
                                    </v-checkbox>
                                  </div>
                                </div>
                              </div>

                              <v-row>
                                <v-col
                                  cols="12"
                                  md="3"
                                  class="py-0">
                                  <div>
                                    <div class="body-2 mb-2">
                                      Start Hour
                                    </div>
    
                                    <v-menu
                                      ref="time"
                                      v-model="time"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="list[selected.category].image_json_object.schedule[0].start"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px">
                                      <template v-slot:activator="{ on, attrs }">
                                        <ValidationProvider 
                                          name="Start Hour" 
                                          v-slot="{ errors, valid }">
                                          <v-text-field
                                            v-on:keyup.enter="save()"
    
                                            readonly
                                            filled
                                            rounded
                                            dense
    
                                            :color="set_color"
                                            placeholder="Ex : 12:00:00"
                                            :append-icon="valid && list[selected.category].image_json_object.schedule[0].start !== '' ? 'mdi-check-circle-outline' : ''"
    
                                            clearable
                                            @click:clear="list[selected.category].image_json_object.schedule[0].start = ''"
                                            v-on="on"
                                            v-bind="attrs"
    
                                            hide-details
                                            
                                            v-model="list[selected.category].image_json_object.schedule[0].start"
                                            :success="valid && list[selected.category].image_json_object.schedule[0].start !== ''"
                                            :error-messages="errors"
                                            required
                                            style="border-radius: 10px;">
                                          </v-text-field>
                                        </ValidationProvider>
                                      </template>
    
                                      <v-time-picker
                                        v-if="time"
                                        v-model="list[selected.category].image_json_object.schedule[0].start"
                                        full-width
                                        :color="set_color"
                                        format="24hr"
                                        @click:minute="$refs.time.save(`${list[selected.category].image_json_object.schedule[0].start}:00`)">
                                      </v-time-picker>
                                    </v-menu>
                                  </div>
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="3"
                                  class="py-0">
                                  <ValidationProvider
                                    name="Duration(s)" 
                                    v-slot="{ errors, valid }">
                                    <div class="body-2 mb-2">
                                      Duration (seconds)
                                    </div>

                                    <v-text-field
                                      filled
                                      rounded
                                      dense

                                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                      type="number"
                                      min="0"

                                      @focus="$event.target.select()"
                                      @keyup="list[selected.category].image_json_object.schedule[0].duration = list[selected.category].image_json_object.schedule[0].duration === '' || parseInt(list[selected.category].image_json_object.schedule[0].duration) < 1 ? 1 : list[selected.category].image_json_object.schedule[0].duration;"
                                      @blur="list[selected.category].image_json_object.schedule[0].duration = list[selected.category].image_json_object.schedule[0].duration === '' || parseInt(list[selected.category].image_json_object.schedule[0].duration) < 1 ? 1 : list[selected.category].image_json_object.schedule[0].duration;"

                                      :color="set_color"
                                      placeholder="Ex : 15"
                                      :append-icon="valid && list[selected.category].image_json_object.schedule[0].duration !== '' ? 'mdi-check-circle-outline' : ''"

                                      suffix="Seconds"

                                      v-model="list[selected.category].image_json_object.schedule[0].duration"
                                      :success="valid && list[selected.category].image_json_object.schedule[0].duration !== ''"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                            <!-- </v-form>
                          </ValidationObserver> -->

                          <div v-if="message.error.length > 0"
                            class="text-center my-4 d-flex align-center">
                            <div
                              class="error--text">
                              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>
                </v-card-text>

                <v-card-text v-else>
                  <v-card
                    flat
                    style="border: 1px dashed #e0e0e0; border-radius: 10px;">
                    <v-card-text
                      class="d-flex align-center">
                      <v-icon size="20">mdi-information-slab-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        <strong>Public Space</strong> data is empty !!!
                      </span>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,

          form: false,

          delete: false,

          schedule: false
        },

        selected: {
          category: '',
          delete: 0
        },

        list: [],
        pagination: {},

        type: [
          {
            text: 'Image Slider',
            value: 'slider'
          },
          {
            text: 'TV & Ads',
            value: 'tv_ads'
          },
          {
            text: 'Video',
            value: 'video'
          },
          {
            text: 'Webview',
            value: 'web_view'
          }
        ],

        form: {
          id: '',
          name: '',
          type: '',
          desc: '',
          duration_minutes: 15,
          image_json_object: {
            slider: [],
            grid: {
              row: [],
              col: []
            },
            schedule: []
          }
        },

        time: false,
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],

        form_schedule: {
          url: '',
          type: '',
          day: [],
          start: '',
          duration: 0,
          play: false
        },

        upload: {
          slider: null,
          grid_row: null,
          grid_col: null,

          schedule: null
        },

        process: {
          load: false,

          form: false,

          form_update: false,

          file: false,
          file_row: false,
          file_col: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        },

        onProgress: null
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder_loader.vue'),
      videoupload: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/video_loader.vue')
    },
    watch: {
      'selected.category': function(val) {
        this.reset(this.list[val])
      },

      'form.type': function(val) {
        if (val === 'video' || val === 'web_view') {
          this.form.duration_minutes = 0

          if (val === 'web_view' && this.form.image_json_object.schedule.length < 1) {
            this.form.image_json_object.schedule = [{
              url: '',
              type: '',
              day: [],
              start: '',
              duration: 0,
              play: false
            }]
          }
        }
      },

      'upload.slider': {
        handler: function () {
          if (this.upload.slider) {
            this.process.file = this.upload.slider.process

            this.onProgress = this.upload.slider.onProgress

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE

              this.list[this.selected.category].image_json_object.slider.push(this.upload.slider.file_url)
            }
          }
        },
        deep: true
      },

      'upload.grid_row': {
        handler: function () {
          if (this.upload.grid_row) {
            this.process.file_row = this.upload.grid_row.process

            this.onProgress = this.upload.grid_row.onProgress

            if (!this.process.file_row) {
              // CALLBACK FROM UPLOAD IMAGE

              this.list[this.selected.category].image_json_object.grid.row.push(this.upload.grid_row.file_url)
            }
          }
        },
        deep: true
      },
      
      'upload.grid_col': {
        handler: function () {
          if (this.upload.grid_col) {
            this.process.file_col = this.upload.grid_col.process

            this.onProgress = this.upload.grid_col.onProgress

            if (!this.process.file_col) {
              // CALLBACK FROM UPLOAD IMAGE

              this.list[this.selected.category].image_json_object.grid.col.push(this.upload.grid_col.file_url)
            }
          }
        },
        deep: true
      },

      'upload.schedule': {
        handler: function () {
          if (this.upload.schedule) {
            this.process.file = this.upload.schedule.process

            this.onProgress = this.upload.schedule.onProgress

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE

              if (this.dialog.schedule) {
                this.form_schedule.url = this.upload.schedule.file_url
              } else {
                this.list[this.selected.category].image_json_object.schedule.push({
                  url: this.upload.schedule.file_url,
                  type: 'video',
                  day: [],
                  start: '',
                  duration: 0,
                  play: false
                })
              }
            }
          }
        },
        deep: true
      },
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch('first')
    },
    methods: {
      async fetch (type) {
        this.process.load = true

        await get(`admin/public-layout/data`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.list = res.result.data
            this.pagination = res.result.meta

            if (type === 'first') {
              this.selected.category = this.list.length > 0 ? this.list.length - 1 : ''
            }

            if (type === 'add' || type === 'delete') {
              this.selected.category = this.list.length - 1
            }

            if (this.list.length > 0) this.reset(this.list[this.selected.category])
          }
        })
      },

      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          name: item !== undefined ? item.name : '',
          type: item !== undefined ? item.type : '',
          desc: item !== undefined ? item.desc : '',
          duration_minutes: item !== undefined ? item.duration_minutes : 15,
          image_json_object: item !== undefined ? item.image_json_object :  {
            slider: [],
            grid: {
              row: [],
              col: []
            },
            schedule: []
          }
        }

        this.process.form = false

        this.message.error = ''
      },

      async save (type) {
        this.message.error = ''

        // const isValid = await this.$refs.form.validate()
        // if (isValid) {
        //   this.process.form = type === 'dialog' ? true : false

        //   this.process.form_update = type === 'card' ? true : false

        //   let url = this.form.id === '' ? 'admin/public-layout/add' : 'admin/public-layout/update'

        //   // SAVE TO REST API
        //   await post(url, {
        //     data: this.form
        //   })
        //   .then((response) => {
        //     let res = response.data

        //     this.process.form = false

        //     this.process.form_update = false

        //     if (res.code === 200) {
        //       this.dialog.form = false

        //       this.dialog.schedule = false

        //       this.dialog.snackbar = true
        //       this.message.success = res.message

        //       let req = this.form.id === '' ? 'add' : 'update'

        //       this.fetch(req)
        //     } else {
        //       this.message.error = res.message
        //     }
        //   })
          
        // } else {
        //   // AUTO FOCUS ON TEXT-FIELD
        //   setTimeout(() => {
        //     const errors = Object.entries(this.$refs.form.errors)
        //       .map(([key, value]) => ({ key, value }))
        //       .filter(error => error['value'].length)
        //     this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
        //       behavior: 'smooth',
        //       block: 'center'
        //     })
        //   }, 10)
        // }

        if (type === 'dialog') {
          this.from_dialog()
        } else {
          this.from_card()
        }
      },

      async from_dialog () {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/public-layout/add' : 'admin/public-layout/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.schedule = false

              this.dialog.snackbar = true
              this.message.success = res.message

              let req = this.form.id === '' ? 'add' : 'update'

              this.fetch(req)
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async from_card() {
        const isValid = await this.$refs.form_card.validate()
        if (isValid) {
          this.process.form_update = true

          let url = this.form.id === '' ? 'admin/public-layout/add' : 'admin/public-layout/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form_update = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.schedule = false

              this.dialog.snackbar = true
              this.message.success = res.message

              let req = this.form.id === '' ? 'add' : 'update'

              this.fetch(req)
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form_card.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form_card.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = id

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/public-layout/delete`, {
          data: {
            id: this.selected.delete
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.code === 200) {

            this.dialog.delete = false

            this.selected.delete = 0
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch('delete')
          } else {
            this.message.error = res.message
          }
        })
      },

      reset_schedule (index) {
        this.form_schedule = this.list[this.selected.category].image_json_object.schedule[index]
      }
    }
  }
</script>